import logo from './img/coin.svg'

const CoinIcon = () => {
  return <img src={logo} height={32} width={32} />
}

export default CoinIcon
